<ng-template #templateModalCompra>
    <div class="checkout-modal">
        <div class="modal-header painelcabecalho d-flex flex-wrap">
            <div class="linha">
                <h4 class="col-2">{{ 'buyer.cotacao.area-comprar.modal-confirmar-compra.titulo' | translate}}</h4>
                @if ((this.userService.userIsCentral()) && userService.userHasCashback() && answerHasCashback) {
                    <div class="col-2 text-center taxa-partsfy">
                        <div class="input-group input-group-sm">
                            <label class="input-group-text">
                                <span>{{ 'buyer.cotacao.area-comprar.modal-confirmar-compra.taxa-partsfy' | translate}}</span>
                            </label>
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="taxa_cashback_partsfy" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" maxlength="4" (blur)="checkTaxaPartsfy_blur()" />
                            <span class="input-group-text"><i class="fa fa-percent" aria-hidden="true"></i></span>
                        </div>
                        <small>(min: 25% - max: 40%)</small>
                    </div>
                }

                @if ((this.userService.userIsCentral())) {
                    <div class="text-center col-2">
                        <select class="form-select form-select-sm" [(ngModel)]="com_complemento_fiscal" style="margin-top: 5px; width: 92%;">
                            <option value="0" selected>{{'buyer.cotacao.area-comprar.modal-confirmar-compra.complemento-fiscal.pendente' | translate}}</option>
                            <option value="1">{{'buyer.cotacao.area-comprar.modal-confirmar-compra.complemento-fiscal.com' | translate}}</option>
                            <option value="2">{{'buyer.cotacao.area-comprar.modal-confirmar-compra.complemento-fiscal.sem' | translate}}</option>
                        </select>
                    </div>
                }

                <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="closeModal(CheckoutModalResponseEnum.somenteFechar);"></button>
            </div>
        </div>
        <div class="modal-body">
            @if (listas?.cnpjs?.length > 0) {
                <div class="cnpj_more_than_one row">
                    <div class="col-md-8">
                        <label>{{ 'buyer.cotacao.area-comprar.modal-confirmar-compra.mais-um-cnpj' | translate}}</label>
                    </div>
                    <div class="col-md-4 divCnpj">
                        <select name="cnpjFaturamento" class="form-select" value="" [disabled]="!listas || !listas.cnpjs || listas.cnpjs.length <= 1">
                            @for (cnpj of listas?.cnpjs; track cnpj) {
                                <option value="{{cnpj.cnpj}}">{{cnpj.cnpj}}</option>
                            }
                        </select>
                    </div>
                </div>
                <hr />
            }
            <fieldset>
                @if (temPecaPF) {
                    <legend class="alerta-bo"><i class="fa fa-exclamation-triangle"></i> {{this.userService.user().firstName}}, {{'buyer.cotacao.area-comprar.modal-confirmar-compra.alerta-bo' | translate}}</legend>
                }
                <div class="row comprar {{ accountService.getCssInIframe() }}" [ngClass]="listas?.cnpjs?.length > 0 ? 'tamanho-cnpj' : 'tamanho-total'">
                    <ng-scrollbar height="auto">
                        <div class="col-md-12">
                            <table class="table tabela-statuscot2">
                                <thead>
                                    <tr>
                                        <th><div class="col-md-4">{{'buyer.cotacao.area-comprar.modal-confirmar-compra.tabela.descricao' | translate}}</div></th>
                                        <th style="width:110px">{{'buyer.cotacao.area-comprar.modal-confirmar-compra.tabela.total' |translate}}</th>
                                        <th style="width:220px">{{'buyer.cotacao.area-comprar.modal-confirmar-compra.tabela.pagamento' |translate}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (answer of chosenAnswers; track answer.answerId) {
                                        <tr class="linha-fornecedor" [ngClass]="userService.userHasCashback() && answer.hasCashback ? 'cashback' : 'no-cashback'">
                                            <td>
                                                <section class="peca-cashback">
                                                    <header>
                                                        <div class="col">
                                                            <b>{{answer.sellerName}}</b>
                                                            @if (userService.userHasCashback() && answer.hasCashback) {
                                                                <em class="fa fa-usd text-success"></em>
                                                            }
                                                            @if (answer.hasCashback) {
                                                                <em class="fa icon-info" tooltip="{{'buyer.cotacao.area-comprar.modal-confirmar-compra.cashback.tooltip'| translate}}"></em>
                                                            }
                                                        </div>
                                                        <div class="col"></div>
                                                    </header>
                                                    @if (answer.isOldAnswer) {
                                                        <div class="linha resposta-antiga">
                                                            <i class="fa fa-exclamation-triangle"></i><span>{{'buyer.cotacao.area-comprar.modal-confirmar-compra.alerta-72' | translate}}</span>
                                                        </div>
                                                    }
                                                    @for (part of answer.parts | filterBy:{ isChosen: true }; track part.itemAnswerId) {
                                                        <div class="linha">
                                                            <div class="col nome-peca truncate">
                                                                <span class="part-details">({{part.selectedQuantity}}) {{part.itemName}} - {{part.deliveryTimeFormatted}}</span>
                                                                <span class="part-details">{{part.brandAndType}} {{ part.is_used ? ' - ' + ('buyer.cotacao.area-comprar.modal-confirmar-compra.peca.usada' | translate) : '' }}</span>
                                                            </div>
                                                            <div class="col" [ngClass]="{ 'display-none': !part.canGenerateCustomizedCashback }">
                                                                @if (part.canGenerateCustomizedCashback) {
                                                                    <div class="input-group input-group-sm">
                                                                        <input type="text" class="form-control form-control-sm" [(ngModel)]="part.discount" currencyMask maxlength="4" (blur)="checkPecaDiscount_blur(answer, part)" />
                                                                        <span class="input-group-text"><i class="fa fa-percent" aria-hidden="true"></i></span>
                                                                    </div>
                                                                }
                                                                @if (part.canGenerateCustomizedCashback) {
                                                                    <small>(max. {{part.discountOriginal | currency:' '}}%)</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                </section>
                                            </td>
                                            <td>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <b class="valor-total" [ngClass]="answer.class">{{answer.totalOriginalFormatted}}</b>
                                                        <br [ngClass]="answer.class" />
                                                        <b class="valor-total" [ngClass]="answer.classCashback">{{answer.totalChosenFormatted}}</b>
                                                        @if ((answer.parts | filterBy:{ isChosen: true, canGenerateCustomizedCashback: true }).length > 1 && answer.hasCashback) {
                                                            <div class="col-md-12 alinhar-desconto-container">
                                                                <a href="javascript:void(0)" (click)="alinharDesconto(answer, true)">{{ 'buyer.cotacao.area-comprar.modal-confirmar-compra.alinhar-desconto' | translate}}</a>
                                                            </div>
                                                        }
                                                        @if (answer.totalCashback > 0) {
                                                            <span class="text-success cashback-por-vendedor" [ngClass]="answer.classCashback">
                                                                {{ 'buyer.cotacao.area-comprar.modal-confirmar-compra.cashback.parte-1' | translate}}
                                                                {{answer.totalCashback | currency : " "}}
                                                                {{ 'buyer.cotacao.area-comprar.modal-confirmar-compra.cashback.parte-2' | translate}}
                                                            </span>
                                                        }
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="mb-3 form-group">
                                                            <select class="form-select form-select-sm resposta_{{answer.answerId}}" value="">
                                                                @for (tipo of answer.selectedPaymentTypesFormatted; track tipo) {
                                                                    <option value="{{tipo.id}}">{{tipo.name}}</option>
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </ng-scrollbar>
                </div>
            </fieldset>
        </div>
        <div class="modal-footer-checkout">
            <div>
                <span>
                    {{ 'buyer.cotacao.area-comprar.modal-confirmar-compra.tabela.total' | translate}}: <b>{{ valorTotalPedidos | currency : "R$ " }}</b>
                </span>
            </div>
            <div>
                @if (valorTotalCashback > 0) {
                    <span class="text-success" style="margin-right: 20px;">
                        {{ 'buyer.cotacao.area-comprar.modal-confirmar-compra.cashback.parte-1' | translate}}
                        {{ valorTotalCashback | currency : " " }}
                        {{ 'buyer.cotacao.area-comprar.modal-confirmar-compra.cashback.parte-2' | translate}}
                    </span>
                }
                <button type="button" class="btn btn-light" (click)="closeModal(CheckoutModalResponseEnum.somenteFechar)">{{'elemento.generico-botao.fechar' | translate}}</button>
                &nbsp;
                <button type="button" data-dismiss="modal" class="btn btn-primary fechar-pedido" (click)="finalizarCompra()">
                    {{ 'buyer.cotacao.area-comprar.modal-confirmar-compra.botao.finalizar' | translate}}
                </button>
            </div>
        </div>
    </div>

    <ngx-ui-loader [loaderId]="'loader-compra'"></ngx-ui-loader>
</ng-template>
